import {getVersionNames, isNextVersion, getFirstVersionName} from './utils'
import {cloneDeep, transform} from 'lodash'

const importVersionSchemas = (versions, relevantVersionNames) =>
  Promise.all(
    relevantVersionNames.map(versionName =>
      versions[versionName]().then(response => {
        const version = response.default || response
        return {...version, versionName}
      }))
  )

export default async function updateObjectStructure(sourceObject, {versions = {}, getUpgradeFunction}) {
  const versionNames = getVersionNames(versions)
  const currentVersion = sourceObject.version || getFirstVersionName(versionNames)

  const relevantVersionNames = versionNames.filter(updateVersion => isNextVersion(currentVersion, updateVersion))

  if (relevantVersionNames.length === 0) {
    return sourceObject
  }

  const importedSchemaVersions = await importVersionSchemas(versions, relevantVersionNames)

  return transform(
    importedSchemaVersions,
    (updatedObjectContent, nextVersion) => {
      const upgradeFunction = getUpgradeFunction(nextVersion)

      upgradeFunction(updatedObjectContent)

      updatedObjectContent.version = nextVersion.versionName
    },
    cloneDeep(sourceObject)
  )
}
